import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Video, Zap, Lock, ArrowRight } from "lucide-react";

const LOGO_URL = process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_videogist-3/artifacts/809w15is_summbee%20logo_just%20bee.png";

function HomePage() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  return (
    <div className="home-page">
      <nav className="navbar">
        <div className="nav-content">
          <div className="nav-logo">
            <img src={LOGO_URL} alt="SummBee" className="logo-image" />
            <span>SummBee</span>
          </div>
          <div className="nav-links">
            <Button onClick={() => navigate("/pricing")} variant="ghost">
              Pricing
            </Button>
            {user ? (
              <Button onClick={() => navigate("/dashboard")} className="cta-button" data-testid="go-to-dashboard-button">
                Go to Dashboard
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")} className="cta-button" data-testid="sign-in-button">
                Sign In
              </Button>
            )}
          </div>
        </div>
      </nav>

      <div className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Turn Videos into
            <span className="highlight"> Actionable Insights</span>
          </h1>
          <p className="hero-subtitle">
            Extract intelligence from any video with AI-powered transcription and summarization.
            Save hours of watching and get straight to what matters.
          </p>
          <div className="hero-cta">
            {user ? (
              <Button onClick={() => navigate("/dashboard")} size="lg" className="primary-cta">
                Get Started <ArrowRight size={20} />
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")} size="lg" className="primary-cta">
                Get Started <ArrowRight size={20} />
              </Button>
            )}
            <Button onClick={() => navigate("/pricing")} size="lg" variant="outline" className="secondary-cta">
              View Pricing
            </Button>
          </div>
        </div>
      </div>

      <div className="features">
        <div className="features-grid">
          <Card className="feature-card">
            <CardHeader>
              <Video className="feature-icon" />
              <CardTitle>Universal Platform Support</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Works with YouTube, Vimeo, and all major video platforms.
                Just paste the link and let SummBee handle the rest.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="feature-card">
            <CardHeader>
              <Zap className="feature-icon" />
              <CardTitle>Lightning Fast Processing</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Advanced AI extracts key points in seconds.
                Get bullet points, structured summaries, and full transcripts.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="feature-card">
            <CardHeader>
              <Lock className="feature-icon" />
              <CardTitle>Secure & Private</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription>
                Your data is encrypted and secure.
                We never share your content with third parties.
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      </div>

      <div className="cta-section">
        <h2>Ready to extract intelligence from videos?</h2>
        <p>Join thousands of professionals who save hours every week</p>
        {user ? (
          <Button onClick={() => navigate("/dashboard")} size="lg" className="final-cta">
            Go to Dashboard <ArrowRight size={20} />
          </Button>
        ) : (
          <Button onClick={() => navigate("/login")} size="lg" className="final-cta">
            Start Free Trial <ArrowRight size={20} />
          </Button>
        )}
      </div>

      <footer className="footer">
        <p>© 2024 SummBee. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default HomePage;
